// import readXlsxFile from 'read-excel-file';
import React, { Component } from 'react';
import { withAuthorization } from '../Session';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import { Container, Row, Col } from 'react-bootstrap';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import { dateFormatUtil ,getFormattedDateTime,getFormattedDate} from '../Utilities';

import KeyboardBackspaceRoundedIcon from '@material-ui/icons/KeyboardBackspaceRounded';
import 'date-fns';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import Form from 'react-bootstrap/Form';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import MaterialTable from 'material-table';

import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import roleType from '../../constants/roles';
import Summary from './Summary';
import SalesSummary from './SalesSummary';
import Alert from 'react-bootstrap/Alert';
import RestServices from '../services/RestServices.js';

import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker
} from '@material-ui/pickers';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        maxWidth: 360
        //   backgroundColor: theme.palette.background.paper,
    }
}));

function MaterialUIPickers(props) {
    const [selectedDate, setSelectedDate] = React.useState(new Date());

    const handleDateChange = (date) => {
        setSelectedDate(date);
        props.setDate(date);
    };

    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Grid container justify="space-around">
                <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="MM/dd/yyyy"
                    margin="normal"
                    id={props.id}
                    label={props.label}
                    value={selectedDate}
                    onChange={handleDateChange}
                    autoOk={true}
                    KeyboardButtonProps={{
                        'aria-label': 'change date'
                    }}
                />
            </Grid>
        </MuiPickersUtilsProvider>
    );
}

function getStoreColumns(detailsType) {
    if (detailsType === 'Fee_Orders') {
        let columns = [
            { title: 'Category', field: 'Category' },
            { title: 'Name', field: 'Name' },
            { title: 'ASIN', field: 'ASIN' },
            { title: 'Date', field: 'Date' },
            { title: 'Qty', field: 'Qty' },
            { title: 'Price(₹)', field: 'Price(₹)' },
            { title: 'Link Type', field: 'Link Type' },
            { title: 'Indirect Sales', field: 'Indirect Sales' },
            { title: 'Device Type Group', field: 'Device Type Group' }
        ];
        return columns;
    } else {
        let columns = [
            { title: 'Category', field: 'Category' },
            { title: 'Name', field: 'Name' },
            { title: 'ASIN', field: 'ASIN' },
            { title: 'Date Shipped', field: 'Date Shipped' },
            { title: 'Seller', field: 'Seller' },
            { title: 'Price(₹)', field: 'Price(₹)' },
            { title: 'Items Shipped', field: 'Items Shipped' },
            { title: 'Returns', field: 'Returns' },
            { title: 'Revenue(₹)', field: 'Revenue(₹)' },
            { title: 'Ad Fees(₹)', field: 'Ad Fees(₹)' },
            { title: 'Device Type Group', field: 'Device Type Group' }
        ];
        return columns;
    }
}

class StoreActivation extends Component {
    _isMounted = false;
    constructor(props) {
        super(props);
        this.state = {
            alert: 0,
            TotalEarning: 0,
            TotalOrder: 0,
            alertMessage: '',
            flag: false,
            flag1: false,
            flag2: false,
            showLoading: true,
            allstoreTag: [],
            storedata: [],
            storeTag: '',
            sheetsFlag: 0,
            step1RevStore: 0,
            step2RevStore: 0,
            step3RevStore: 0,
            step4RevStore: 0,
            selectedTab: '',
            uploadSpinner: false,
            fromDate: this.getFormattedDate('firstDay'),
            toDate: this.getFormattedDate('lastDay'),
            storeSheetdata: ['Fee_Orders'],
            lastUpdatedOrders: '',
            UpcommingSales: ''
        };
    }

    getFormattedDate(dateType) {
        var date = new Date(),
            y = date.getFullYear(),
            m = date.getMonth();
        if (dateType == 'firstDay') {
            var firstDay = new Date(y, m, 1);
        } else {
            var firstDay = new Date(y, m + 1, 0);
        }
        var dd = String(firstDay.getDate()).padStart(2, '0');
        var mm = String(firstDay.getMonth() + 1).padStart(2, '0');
        var yyyy = firstDay.getFullYear();

        var newdate = yyyy + '-' + mm + '-' + dd;
        return newdate;
    }
    async componentDidMount() {
        this._isMounted = true;
        this.loadData();
        this.getUpcommingSales();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    async getUpcommingSales() {
        await RestServices.getUpcommingSales(
            localStorage.getItem('FirebaseToken')
        )
            .then((response) => response.json())
            .then(async (responseData) => {
                

                if (this._isMounted) {
                    this.setState({ UpcommingSales: responseData });
                }
            })

            .catch((err) => {
                if (this._isMounted) {
                    this.setState({
                        showLoading: false,
                        alert: 1,
                        alertMessage: err.message
                    });
                }
            });
    }

    async loadData() {
        await RestServices.getFeeOrdersLastUpdate(
            localStorage.getItem('FirebaseToken')
        )
            .then((response) => response.json())
            .then(async (responseData) => {
                if (responseData.error) {
                    if (this._isMounted) {
                        this.setState({
                            alert: 1,
                            alertMessage: responseData.error,
                            showLoading: false
                        });
                    }
                } else {
                    if (this._isMounted) {
                        this.setState({
                            flag1: true,
                            lastUpdatedOrders: responseData,
                            showLoading: false
                        });
                    }
                }
            })

            .catch((err) => {
                if (this._isMounted) {
                    this.setState({
                        showLoading: false,
                        alert: 1,
                        alertMessage: err.message,
                        showLoading: false
                    });
                }
            });
    }


   getFormattedDateTime(date){
		var time = new Date(new Date(date).toString());
		var timeString = time.toLocaleString('en-US', { hour: "2-digit",minute: "2-digit", })
	
		const tempDate = new Date(date).toString().split(' ');
		const formattedDate = tempDate['2']+' '+tempDate['1']+', '+tempDate['3']+' - '+timeString;
		return formattedDate
	}
	
    render() {
        return (
            <Container>
                {this.state.alert === 1 && (
                    <Row>
                        <Col>
                            <Alert variant="danger">
                                {this.state.alertMessage}
                            </Alert>
                        </Col>
                    </Row>
                )}

                <Row style={{ justifyContent: 'space-between' }}>
                    <h4 style={{ marginLeft: '1rem', marginRight: '1rem' }}>
                        Store Activation
                    </h4>
                    <h6 style={{ marginTop: '1rem', marginRight: '1rem' }}>
                        TOV = Total Order Value
                    </h6>
                </Row>

                {this.state.flag1 && (
                    <div>
                        <Row>
                            <p
                                style={{
                                    marginLeft: '1rem',
                                    marginRight: '1rem'
                                }}
                            >
                                Last Updated: {getFormattedDateTime(this.state.lastUpdatedOrders)}
                            </p>
                        </Row>
                        <div>
                            <hr />
                        </div>

                        <Summary />
                    </div>
                )}

                {this.state.UpcommingSales.salefrom && (
                    <div>
                        <Row style={{ justifyContent: 'space-between' }}>
                            <h4
                                style={{
                                    marginLeft: '1rem',
                                    marginRight: '1rem'
                                }}
                            >
                                {this.state.UpcommingSales.saletitle} Activation
                                ({this.state.UpcommingSales.salefrom} To{' '}
                                {this.state.UpcommingSales.saleto})
                            </h4>
                        </Row>

                        <div>
                            <hr />
                        </div>

                        <SalesSummary
                            UpcommingSales={this.state.UpcommingSales}
                        />
                    </div>
                )}
            </Container>
        );
    }
}

const condition = (authUser) => !!authUser;
export default withAuthorization(condition)(StoreActivation);
